import { AlloyLegacyThemeDesignTokens, CheckboxDesignTokens } from '../types';
import { buildBoxShadow } from './common';
import { WeaveTheme } from '../types/weaveTypes';

type WeaveTokens = WeaveTheme['tokens'];

const px = (value: number) => `${value}px`;

export const getCheckboxTokensAlloy = (
  theme: AlloyLegacyThemeDesignTokens,
  transitionDuration: number,
  transitionEasing: string,
): CheckboxDesignTokens => ({
  _: {
    'border-style': 'solid',
    'border-radius': px(theme.borderRadius.small),
    'border-color': theme.tokens.colors.border.value,
    cursor: 'pointer',
    color: theme.tokens.colors.icon.inverse.value,
    '& svg': {
      display: 'block',
    },
    '&:hover': {
      'box-shadow': theme.halos.hover,
    },
    '&:focus-within': {
      'box-shadow': theme.halos.focus,
    },
    '&:active': {
      'box-shadow': theme.halos.active,
      'border-color': theme.colors.charcoal500,
    },
    transition: `box-shadow ${transitionDuration}ms ${transitionEasing}, border-color ${transitionDuration}ms ${transitionEasing}`,
  },
  checked: {
    true: {
      _: {},
      disabled: {
        true: {
          'background-color':
            theme.tokens.colors.background.neutral.inactive.value,
          'border-color': theme.tokens.colors.border.inactive.value,
          color: theme.tokens.colors.icon.inactive.value,
          cursor: 'not-allowed',
          'box-shadow': 'none',
        },
        false: {
          'background-color': theme.tokens.colors.background.selected.value,
        },
      },
    },
    false: {
      _: {
        'background-color': 'inherit',
      },
      disabled: {
        true: {
          'border-color': theme.tokens.colors.border.inactive.value,
          cursor: 'not-allowed',
        },
        false: {},
      },
    },
  },
});

export const getCheckboxTokensWeave = (
  tokens: WeaveTokens,
): CheckboxDesignTokens => {
  const checkbox = tokens?.component?.checkbox;

  const transition = `${checkbox?.['transition-property'] || 'box-shadow'} ${checkbox?.['transition-duration'] || '300ms'} ${checkbox?.['transition-timing-function'] || 'cubic-bezier(0.4, 0, 0.2, 1)'}`;

  return {
    _: {
      'border-style': checkbox?.['border-style'],
      'border-radius': checkbox?.['border-radius'],
      'border-color': checkbox?.['border-color']?.default,
      'background-color': checkbox?.['background-color']?.default,
      color: checkbox?.icon?.fill,
      cursor: 'pointer',
      '& svg': {
        display: 'block',
      },
      '&:hover': {
        'box-shadow': buildBoxShadow(checkbox, 'hover'),
      },
      '&:focus-within': {
        'box-shadow': `0px 0px 0px 0px white, ${buildBoxShadow(checkbox, 'focus')}`,
      },
      '&:active': {
        'box-shadow': buildBoxShadow(checkbox, 'pressed'),
      },
      transition,
    },
    checked: {
      true: {
        _: {},
        disabled: {
          true: {
            'background-color': checkbox?.['background-color']?.selected,
            'border-color': checkbox?.['border-color']?.default,
            color: checkbox?.icon?.fill,
            opacity: checkbox?.opacity?.disabled,
            cursor: 'not-allowed',
            'box-shadow': 'none',
          },
          false: {
            'background-color': checkbox?.['background-color']?.selected,
          },
        },
      },
      false: {
        _: {
          'background-color': 'inherit',
        },
        disabled: {
          true: {
            'border-color': checkbox?.['border-color']?.default,
            opacity: checkbox?.opacity?.disabled,
            cursor: 'not-allowed',
          },
          false: {},
        },
      },
    },
  };
};
